import React, { useEffect } from 'react';
import config from 'utils/config';
import Card from 'components/Card';
import CenterContent from 'components/CenterContent';
import StoreActions from '../../../../actions/storeActions';
import AlertRenderer from '../../../shared/alertRenderer';
import LanguageSwitcher from './LanguageSwitcher';
import useRedirectAfterLogin from './useRedirectAfterLogin';
function AuthPageWrapper(_ref) {
  var children = _ref.children,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 396 : _ref$width;
  useEffect(function () {
    StoreActions.stopPollForMessages();
  }, []);
  useRedirectAfterLogin();
  return /*#__PURE__*/React.createElement(React.Fragment, null, config.userLanguageEnabled && /*#__PURE__*/React.createElement(LanguageSwitcher, null), /*#__PURE__*/React.createElement(CenterContent, {
    contentWidth: width,
    height: "100%",
    p: ['xs', 'm']
    // Spacing for the language selector
    ,
    pt: 45,
    breakpoints: "xs"
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised"
  }, children)), /*#__PURE__*/React.createElement(AlertRenderer, null));
}
export default AuthPageWrapper;